import { extendTheme  } from '@chakra-ui/react'
export const theme = extendTheme({
   colors:{ 
       
        blue:{
            600:"#141628",
            500:"#141628",
            400:"#262A43",
            300:"#1B1E32",
            200:"#383D5E",
            100:"#d1d5e8",
        },
        pink:{
            500:"#FD4370",
            600:"#f82d60"
        },
        gray:{
            50:"#f6f6f7",
            100:"#eee",
            200:"#d4d4d4",
            300:"#9e9ea7",
            400:"#666665",
            900:"#111"
        },
    },
    fonts:{
        heading:"Inter",
        body:"Inter"
    },
    fontSizes:{
        xs:"0.75rem",
        sm:"0.875rem",
        md:"1rem",
        lg:"1.125rem",
        xl:"1.25rem",
        "2xl":"1.5rem",
        "3xl": "1.875rem",
        "4xl":"2.25rem",
        "5xl":"3rem",
        "6xl":"3.75rem",
        "7xl":"4.5rem",
        "8xl":"6rem",
        "9xl":"8rem",
    },
    styles:{
        global:{
            body:{
                color:"white"
            }
        }
    }
})